import { RegexUtils } from '../../../core';
import { regexValidator } from '../../components/observation-form/observation-validators';
import { setDateTimeWithService } from '../../observation.services';

const releveEpe = [
  {
    fieldName: 'cabinAndFaisceau',
    mandatory: true,
    group: [
      {
        fieldName: 'cabin',
        validator: regexValidator(RegexUtils.alphaNumericAndSpecialCharacters),
        mandatory: true,
      },
      {
        fieldName: 'trainStorageChoice',
        mandatory: true,
      },
    ],
  },
  {
    fieldName: 'materialType',
    mandatory: true,
  },
  {
    fieldName: 'cassette',
    mandatory: true,
    visibleIf: (fields) => fields.materialType === 'MI09_MI2N',
    group: [
      {
        fieldName: 'cassetteNoted',
        validator: regexValidator(RegexUtils.numeric),
        mandatory: true,
        visibleIf: (fields) => fields.materialType === 'MI09_MI2N' || fields.materialType === 'MI84',
      },
      {
        fieldName: 'cassetteInstalled',
        validator: regexValidator(RegexUtils.numeric),
        mandatory: true,
        visibleIf: (fields) => fields.materialType === 'MI79_MI84R',
      },
    ],
  },
  {
    fieldName: 'tachy',
    mandatory: false,
    visibleIf: (fields) => fields.materialType === 'MI09_MI2N' || fields.materialType === 'MI84',
  },
  {
    fieldName: 'sens',
    mandatory: true,
  },
  {
    fieldName: 'period',
    mandatory: true,
  },
  {
    fieldName: 'dateTime',
    mandatory: true,
    defaultValue: ({ driveLog }) =>
      setDateTimeWithService(driveLog?.realized_date_start, new Date()),
  },
];

export default releveEpe;
